import React from 'react';

import '../Image/details-asset.styles.scss';

class Video extends React.Component {
    componentDidMount() {
        const script1 = document.createElement('script');
        script1.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        script1.async = true;
        document.body.appendChild(script1);
    }
    
    render() {
        const style1 = {
            padding: '56.25% 0 0 0',
            position: 'relative'
        }
        const style2 = {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%'
        }

        return (
            <div className="details-asset">
                <div className="container">
                    <div className="wistia_responsive_padding" style={style1}><div className="wistia_responsive_wrapper" style={style2}><iframe src={`https://fast.wistia.net/embed/iframe/${this.props.id}?seo=false&videoFoam=true`} title={this.props.title} allowtransparency="true" frameBorder="0" scrolling="no" className="wistia_embed" name="wistia_embed" allowFullScreen mozallowfullscreen="true" webkitallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true" width="100%" height="100%"></iframe></div></div>
                </div>
            </div>
        )
    }
}

export default Video;